import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify, Auth } from 'aws-amplify';

import 'normalize.css';
import 'styles/global.scss';
import IntlApp from './IntlApp';
import reportWebVitals from './reportWebVitals';
import store from './app/store';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';

Amplify.configure({
  API: {
    endpoints: [
      {
        name: 'API',
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        custom_header: async () => {
          return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
        }
      },
    ]
  },
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT,
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
      domain: process.env.REACT_APP_AUTH_DOMAIN,
      scope: ["email", "openid"],
      redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_SIGNIN,
      redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_SIGNOUT,
      responseType: "code"
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider>
        <IntlApp />
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
